import { Twin, Trend } from '../components/canvas.jsx';
import { Pill, Stat, Why } from '../components/ui.jsx';
import { summarise } from '../lib/record.js';

export default function Ori({ record, onGo }) {
  const { last, total, locked } = summarise(record.readings);

  const hour = new Date().getHours();
  const greeting = hour < 12 ? 'Good morning' : hour < 18 ? 'Good afternoon' : 'Good evening';

  return (
    <section>
      <div className="vh">
        <p className="eyebrow">{greeting}</p>
        <h1>Your Ori</h1>
        <p>
          Not a dashboard. A living thing that beats at the rate Ori last found in you, and that visibly unsettles when
          the reading was poor — so the uncertainty is in the object rather than buried in a footnote.
        </p>
      </div>

      <div className="grid2">
        <Twin reading={last} monkTone={record.monkTone} />

        <div className="stack">
          <div className="row">
            <p className="eyebrow" style={{ margin: 0 }}>
              Latest reading
            </p>
            {!last ? (
              <Pill kind="off">no reading yet</Pill>
            ) : last.locked ? (
              <Pill kind="ok">clear signal</Pill>
            ) : (
              <Pill kind="bad">could not read</Pill>
            )}
          </div>

          <div className="trio">
            <Stat label="Pulse" value={last?.locked ? Math.round(last.heartRateBpm) : '—'} unit="bpm" />
            <Stat
              label="Breathing"
              value={last?.locked && last.breathsPerMinute ? Math.round(last.breathsPerMinute) : '—'}
              unit="/min"
            />
            <Stat
              label="Variability"
              value={last?.locked && last.variabilityMs ? Math.round(last.variabilityMs) : '—'}
              unit="ms"
            />
          </div>

          <div className="card">
            <div className="row" style={{ marginBottom: '12px' }}>
              <p className="eyebrow" style={{ margin: 0 }}>
                Recent readings
              </p>
              <span className="mono" style={{ fontSize: '0.82rem', color: 'var(--faint)' }}>
                {total ? `${locked} of ${total} succeeded` : 'nothing yet'}
              </span>
            </div>
            <Trend readings={record.readings} />
          </div>

          <div className="btnrow">
            <button type="button" className="btn" onClick={() => onGo('scan')}>
              New reading
            </button>
            <button type="button" className="btn ghost" onClick={() => onGo('care')}>
              Where to go next
            </button>
          </div>
        </div>
      </div>

      <Why>
        <strong>This is the layer digital health has failed at for fifteen years.</strong> A number in a dashboard does
        not bring anyone back tomorrow; a thing that is alive and is yours might. It is an unproven bet, it is what a
        games division is actually for, and it has to be measured from day one and abandoned if it does not work.
      </Why>
    </section>
  );
}
